import Vue from 'vue'
import Router from 'vue-router'
import Store from '@/store/store'

Vue.use(Router)

let router = new Router({
  routes: [
    // {
    //   path: '/output',
    //   name: 'output',
    //   component: () => import('./views/Output.vue')
    // },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('./views/Admin.vue')
    },
    {
      path: '/company/:company_id/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
      meta: { isPublic: true }
    },
    {
      path: '/company/:company_id/reset_password',
      name: 'reset_password',
      component: () => import('./views/ResetPassword.vue'),
      meta: { isPublic: true }
    },
    {
      path: '/company/:company_id/change_password',
      name: 'change_password',
      component: () => import('./views/ChangePassword.vue'),
      meta: { isPublic: true }
    },
    {
      path: '/new_account',
      name: 'new_account',
      component: () => import('./views/NewAccount.vue')
    },
    {
      path: '/company/:company_id/survey/:survey_id/result/:user_id',
      name: 'result',
      component: () => import('./views/Result.vue')
    },
    {
      path: '/company/:company_id/results/',
      name: 'results',
      component: () => import('./views/Results.vue')
    },
    {
      path: '/company/:company_id/home/',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/company/:company_id/admin_home/',
      name: 'admin_home',
      component: () => import('./views/AdminHome.vue')
    },
    {
      path: '/company/:company_id/manage_surveys/',
      name: 'manage_surveys',
      component: () => import('./views/ManageSurveys.vue')
    },
    {
      path: '/company/:company_id/manage_survey/:survey_id',
      name: 'manage_survey',
      component: () => import('./views/ManageSurvey.vue')
    },
    {
      path: '/company/:company_id/manage_survey/:survey_id/aggregate_surveys',
      name: 'aggregate_surveys',
      component: () => import('./views/AggregateSurveys.vue')
    },
    {
      path: '/company/:company_id/users/',
      name: 'users',
      component: () => import('./views/Users.vue')
    },
    {
      path: '/companies',
      name: 'companies',
      component: () => import('./views/Companies.vue')
    },
    {
      path: '/company/:company_id/survey/:survey_id/print_result/:user_id',
      name: 'print_result',
      component: () => import('./views/ResultPrint.vue')
    },
    {
      path: '/company/:company_id/surveys',
      name: 'surveys',
      component: () => import('./views/Surveys.vue')
    },
    {
      path: '/company/:company_id/survey/:survey_id/answer/:answer_sheet_id',
      name: 'answer',
      component: () => import('./views/AnswerSurvey.vue'),
      meta: { isPublic: true }
    },
    {
      path: '/company/:company_id/targets',
      name: 'targets',
      component: () => import('./views/Targets.vue')
    },
    {
      path: '/company/:company_id/target/:sheet_id',
      name: 'target',
      component: () => import('./views/EditTarget.vue')
    },
    {
      path: '/company/:company_id/print_target/:sheet_id',
      name: 'print_target',
      component: () => import('./views/PrintTarget.vue')
    },
  ]
})
router.beforeEach((to, from, next) => {
  let requiresAuth = to.matched.some(record => !record.meta.isPublic)
  const isLoggedIn = Store.getters["auth/isLoggedIn"]
  
  if (requiresAuth && !isLoggedIn) {
    Store.commit('auth/saveToUrl', to.fullPath)
    
    next({ name: "login", params: { company_id: to.params.company_id } });
  } 
  else if(to.name == "answer"){
    Store.commit('auth/saveToUrl', to.fullPath)
    next()
  }
  else{
    next();
  }
})

export default router